import clsx from 'clsx';

export const styles = {
  container: 'tw-w-full tw-overflow-hidden tw-rounded-md tw-bg-white tw-shadow-md tw-border tw-border-neutral-200',
  headerRow: 'tw-bg-neutral-50 tw-border-b tw-border-neutral-200',
  stickyHeader: 'tw-sticky tw-top-0 tw-z-10 tw-bg-neutral-50',
  headerCell: 'tw-px-6 tw-py-4 tw-text-xs tw-font-bold tw-text-neutral-700 tw-uppercase tw-tracking-wider tw-bg-neutral-50',
  checkboxCell: 'tw-w-14 tw-px-6 tw-py-4',
  checkbox: 'tw-h-4 tw-w-4 tw-rounded tw-border-neutral-300 tw-text-primary-600 focus:tw-ring-primary-500 focus:tw-ring-offset-0 tw-cursor-pointer',
  bodyCell: 'tw-px-6 tw-py-4 tw-text-sm tw-text-neutral-800',
  emptyState: 'tw-px-6 tw-py-16 tw-text-center tw-text-neutral-500',
  loadingContainer: 'tw-flex tw-items-center tw-justify-center tw-gap-3 tw-text-primary-600',
};

export const getRowStyles = (isClickable: boolean, isSelected: boolean) =>
  clsx(
    'tw-transition-colors tw-duration-150',
    'tw-border-b tw-border-neutral-100',
    isClickable && 'tw-cursor-pointer hover:tw-bg-primary-50',
    isSelected && 'tw-bg-primary-100 tw-border-l-4 tw-border-l-primary-500'
  );

export const getAlignClass = (align?: 'left' | 'center' | 'right') => {
  switch (align) {
    case 'center':
      return 'tw-text-center';
    case 'right':
      return 'tw-text-right';
    default:
      return 'tw-text-left';
  }
};
